import React from 'react';
import MoodleBadgeFlags from './MoodleBadgeFlags';

/**
 * Hauptkomponente für Schüler-Flaggen
 * Verwaltet verschiedene Flag-Typen und rendert sie entsprechend
 */
const StudentFlags = ({ 
  student, 
  taskData, 
  containerWidth, 
  rowHeight = 30,
  onFlagClick = null,
  refreshSeed = 0,
  userBadgeData = [],
  showOutsideBadges = true // Neuer Parameter
}) => {
  const handleFlagClick = (flag) => {
    if (onFlagClick) {
      onFlagClick(flag, student);
    }
  };
  
  return (
    <div style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      pointerEvents: 'auto' // Geändert zu 'auto' um Tooltips zu ermöglichen
    }}>
      {/* Render flags based on task evidence type */}
      {taskData.evidenceType === 'moodle-badge' && (
        <div style={{ pointerEvents: 'auto' }}>
          <MoodleBadgeFlags
            student={student}
            taskData={taskData}
            containerWidth={containerWidth}
            rowHeight={rowHeight}
            onFlagClick={handleFlagClick}
            refreshSeed={refreshSeed}
            userBadgeData={userBadgeData}
            showOutsideBadges={showOutsideBadges} // Weiterleitung des Parameters
          />
        </div>
      )}
      
      {/* Hier können weitere Flag-Typen hinzugefügt werden */}
      {/* 
      {taskData.evidenceType === 'manual' && (
        <ManualEvidenceFlags ... />
      )}
      {taskData.evidenceType === 'simsys-exam' && (
        <SimsysExamFlags ... />
      )}
      */}
    </div>
  );
};

export default StudentFlags;